// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2tXzH","colMaxWidth":"Table_colMaxWidth__3rf1a"};